/** @jsx jsx */
import Swiper from '../Swiper/Swiper';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';
import Overlay from '../Section/Overlay';
import {
  HeroSection as sectionStyles,
  Swiper as swiperStyles,
  Overlay as overlayStyles,
} from './HeroSection.styles';

export default function HeroSection({ images, children, ...rest }) {
  const content = images ? (
    <Overlay sx={overlayStyles}>{children}</Overlay>
  ) : (
    children
  );
  return (
    <Section container="none" sx={sectionStyles} {...rest}>
      {images && (
        <Swiper
          images={images}
          navigation={false}
          pagination={true}
          sx={swiperStyles}
        />
      )}
      {content}
    </Section>
  );
}
